import initialState from '../../../store/initialState';
import * as liveAvailableShiftsTypes from '../services/LiveAvailableShiftsActionType';

const types = { ...liveAvailableShiftsTypes };

const liveAvailableShiftsReducer = (state = initialState.liveAvailableShiftsReducer, action) => {
    switch (action.type) {
        case types.FETCH_LIVE_AVAILABLE_SHIFTS_REQUEST:
            return { ...state, isLiveAvailableShiftsLoading: true };
        case types.FETCH_LIVE_AVAILABLE_SHIFTS_SUCCESS:
            return {
                ...state,
                isLiveAvailableShiftsLoading: false,
                liveAvailableShiftsData: action.payload?.values?.listAvailableShifts || [],
                liveAvailableShiftsDataTotal: action.payload?.recordsTotal || 0,
                ID: action.payload?.values?.CapacityVsDemandTableID || state.ID,
                LastRefreshedInfo: action.payload?.values?.LastRefreshedOn || state.LastRefreshedInfo,
            };
        case types.FETCH_LIVE_AVAILABLE_SHIFTS_FAILURE:
            return {
                ...state,
                isLiveAvailableShiftsLoading: false,
                liveAvailableShiftsData: [],
                liveAvailableShiftsDataTotal: 0,
            };

        // Modal-only "Schedule View" table — isolated from liveAvailableShiftsData/
        // liveAvailableShiftsDataTotal so opening/filtering the modal never overwrites
        // the main table's data.
        case types.FETCH_MODAL_SCHEDULE_REQUEST:
            return { ...state, isModalScheduleLoading: true };
        case types.FETCH_MODAL_SCHEDULE_SUCCESS:
            return {
                ...state,
                isModalScheduleLoading: false,
                modalScheduleData: action.payload?.values?.listAvailableShifts || [],
                modalScheduleDataTotal: action.payload?.recordsTotal || 0,
            };
        case types.FETCH_MODAL_SCHEDULE_FAILURE:
            return {
                ...state,
                isModalScheduleLoading: false,
                modalScheduleData: [],
                modalScheduleDataTotal: 0,
            };
        case types.FETCH_LIVE_AVAILABLE_SHIFTS_FILTERS_REQUEST:
            return { ...state, isLiveAvailableShiftsFiltersLoading: true };
        case types.FETCH_LIVE_AVAILABLE_SHIFTS_FILTERS_SUCCESS:
            return {
                ...state,
                isLiveAvailableShiftsFiltersLoading: false,
                liveAvailableShiftsFilters: action.payload?.values || {},
            };
        case types.FETCH_LIVE_AVAILABLE_SHIFTS_FILTERS_FAILURE:
            return { ...state, isLiveAvailableShiftsFiltersLoading: false, liveAvailableShiftsFilters: {} };
        case types.FETCH_LIVE_AVAILABLE_SHIFTS_WORKLIST_REQUEST:
            return { ...state, isLiveAvailableShiftsWorklistLoading: true };
        case types.FETCH_LIVE_AVAILABLE_SHIFTS_WORKLIST_SUCCESS:
            return {
                ...state,
                isLiveAvailableShiftsWorklistLoading: false,
                liveAvailableShiftsWorklists: action.payload?.values || action.payload?.value || [],
            };
        case types.FETCH_LIVE_AVAILABLE_SHIFTS_WORKLIST_FAILURE:
            return { ...state, isLiveAvailableShiftsWorklistLoading: false, liveAvailableShiftsWorklists: [] };

        case types.FETCH_LEGEND_TABLE_DATA_REQUEST:
            return { ...state, isLegendLoading: true };
        case types.FETCH_LEGEND_TABLE_DATA_SUCCESS:
            return {
                ...state,
                isLegendLoading: false,
                LegendDDList: action.payload?.values?.Item2?.legendModel || [],
                ID: action.payload?.values?.Item1 || null,
                LastRefreshedInfo: action.payload?.values?.Item2?.CapacityVsDemandTableInfo.PublishedOn || '',
                datemodel: action.payload?.values?.Item2?.datemodel || []
            };
        case types.FETCH_LEGEND_TABLE_DATA_FAILURE:
            return {
                ...state,
                isLegendLoading: false,
                LegendDDList: [],
                ID: null,
                LastRefreshedInfo: '',
                datemodel: []
            };

        case types.FETCH_PRIORITY_GROUPING_LEGEND_REQUEST:
            return { ...state, isPriorityGroupingLegendLoading: true };
        case types.FETCH_PRIORITY_GROUPING_LEGEND_SUCCESS:
            return {
                ...state,
                isPriorityGroupingLegendLoading: false,
                priorityGroupingLegendList: action.payload?.values || [],
            };
        case types.FETCH_PRIORITY_GROUPING_LEGEND_FAILURE:
            return {
                ...state,
                isPriorityGroupingLegendLoading: false,
                priorityGroupingLegendList: [],
            };

        case types.FETCH_RAD_REQUEST_TYPE_REQUEST:
            return {
                ...state,
                isRadRequestTypeLoading: true,
            };
        case types.FETCH_RAD_REQUEST_TYPE_SUCCESS:
            return {
                ...state,
                isRadRequestTypeLoading: false,
                radRequestTypeOptions: action.payload || [],
            };
        case types.FETCH_RAD_REQUEST_TYPE_FAILURE:
            return {
                ...state,
                isRadRequestTypeLoading: false,
                radRequestTypeOptions: [],
            };

        case types.FETCH_SCHEDULE_RECURRENCE_REQUEST:
            return {
                ...state,
                isRecurrenceLoading: true,
            };
        case types.FETCH_SCHEDULE_RECURRENCE_SUCCESS:
            return {
                ...state,
                isRecurrenceLoading: false,
                recurrenceOptions: action.payload || [],
            };
        case types.FETCH_SCHEDULE_RECURRENCE_FAILURE:
            return {
                ...state,
                isRecurrenceLoading: false,
                recurrenceOptions: [],
            };

        case types.SAVE_RAD_REQUEST_REQUEST:
            return {
                ...state,
                isSaveRadRequestLoading: true,
            };
        case types.SAVE_RAD_REQUEST_SUCCESS:
            return {
                ...state,
                isSaveRadRequestLoading: false,
            };
        case types.SAVE_RAD_REQUEST_FAILURE:
            return {
                ...state,
                isSaveRadRequestLoading: false,
            };

        case types.SAVE_LIVE_AVAILABLE_SHIFTS_FILTERS_REQUEST:
            return {
                ...state,
                isSaveLiveAvailableShiftsFiltersLoading: true,
            };
        case types.SAVE_LIVE_AVAILABLE_SHIFTS_FILTERS_SUCCESS:
            return {
                ...state,
                isSaveLiveAvailableShiftsFiltersLoading: false,
            };
        case types.SAVE_LIVE_AVAILABLE_SHIFTS_FILTERS_FAILURE:
            return {
                ...state,
                isSaveLiveAvailableShiftsFiltersLoading: false,
            };


        // Common cases
        case types.UPDATE_LIVE_AVAILABLE_SHIFTS_REDUCER:
            return { ...state, ...action.payload };

        default:
            return state;
    }
}

export default liveAvailableShiftsReducer;